import jwtDecode from "jwt-decode";
import { DecodedToken } from "src/redux/types/auth";

export default function parseToken (token: string) {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    return null; 
  }
}